<app-dialog
  #dialog
  [key]="'set-primary-modal'"
  [action]="'set-primary-modal'"
  [headerTheme]="'simple'"
  [title]="'Definir empresa principal'"
  [maxWidth]="'480px'">
  <div class="p-4">
    <div class="row g-3">
      <div class="col-12">
        <app-select
          [label]="'Empresa*'"
          [options]="companyOptions"
          [placeholder]="'Buscar empresa...'"
          [hasFilter]="true"
          [(ngModel)]="selectedCompanyId" />
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        [loadingText]="'Definindo...'"
        label="Definir como principal"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
